import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

import { HistoryEvent } from '@api/types';
import { HistoryItemIcon } from '@react/Pages/AccountSettingsPage/YourDataSection/AccountHistoryTile/HistoryItemIcon/HistoryItemIcon';
import { getLocalizedKind } from '@react/constants/historyEvent/localization/kindLocalization';
import { getLocalizedMessage } from '@react/constants/historyEvent/localization/messageLocalization';

const DATE_FORMAT = 'YYYY-MM-DD';
const TIME_FORMAT = 'HH:mm:ss';

function getDate(date: Date) {
  return moment.utc(date).format(DATE_FORMAT);
}

function getTime(date: Date) {
  return moment.utc(date).format(TIME_FORMAT);
}

export interface AuditEventProps {
  event: HistoryEvent;
}

export const HistoryItem: React.FC<AuditEventProps> = ({ event }) => {
  const { attributes } = event;

  return (
    <li className={classNames({ internal: attributes.internal })}>
      <div className="audit-list-item flex-box-row">
        <div className={classNames('flex-auto event-icon', attributes.category)}>
          <HistoryItemIcon event={event} />
        </div>

        <div className="flex-auto event-actor">{attributes.actor_name}</div>

        <div className={classNames('flex-auto event-action', attributes.category)}>{attributes.action}</div>

        <div className="flex-auto event-type">{getLocalizedKind(attributes.kind)}</div>

        <div className="flex-one event-description">{getLocalizedMessage(attributes.name, attributes.parameters)}</div>

        <div className="flex-auto event-time event-date">{getDate(attributes.occurred_at)}</div>

        <div className="flex-auto event-time">{getTime(attributes.occurred_at)}</div>
      </div>
    </li>
  );
};
